export const landingFeatureIcons = [
	{ id: "award", label: "Award", keywords: "badge achievement prize" },
	{ id: "bolt", label: "Bolt", keywords: "fast energy lightning" },
	{ id: "book", label: "Book", keywords: "read learn course education" },
	{ id: "briefcase", label: "Briefcase", keywords: "business work job" },
	{ id: "store", label: "Store", keywords: "shop commerce retail" },
	{ id: "idea", label: "Idea", keywords: "bulb light creative" },
	{ id: "calendar", label: "Calendar", keywords: "date schedule" },
	{ id: "event", label: "Event", keywords: "calendar date schedule" },
	{ id: "camera", label: "Camera", keywords: "photo image media" },
	{ id: "certificate", label: "Certificate", keywords: "award course education" },
	{ id: "bar-chart", label: "Bar chart", keywords: "analytics data growth" },
	{ id: "line-chart", label: "Line chart", keywords: "analytics data growth" },
	{ id: "pie-chart", label: "Pie chart", keywords: "analytics data report" },
	{ id: "check", label: "Check", keywords: "done complete yes" },
	{ id: "checklist", label: "Checklist", keywords: "tasks list complete" },
	{ id: "verified", label: "Verified", keywords: "check approved complete" },
	{ id: "clock", label: "Clock", keywords: "time fast schedule" },
	{ id: "cloud", label: "Cloud", keywords: "online storage internet" },
	{ id: "code", label: "Code", keywords: "developer programming" },
	{ id: "coin", label: "Coin", keywords: "money price currency" },
	{ id: "compass", label: "Compass", keywords: "direction navigation explore" },
	{ id: "celebration", label: "Celebration", keywords: "confetti party launch" },
	{ id: "credit-card", label: "Credit card", keywords: "payment money checkout" },
	{ id: "desktop", label: "Desktop", keywords: "computer device website" },
	{ id: "diamond", label: "Diamond", keywords: "premium quality value" },
	{ id: "download", label: "Download", keywords: "file save digital" },
	{ id: "file", label: "File", keywords: "document resource" },
	{ id: "flag", label: "Flag", keywords: "goal milestone" },
	{ id: "flame", label: "Flame", keywords: "hot popular energy" },
	{ id: "gift", label: "Gift", keywords: "present bonus reward" },
	{ id: "headphones", label: "Headphones", keywords: "audio music support" },
	{ id: "heart", label: "Heart", keywords: "love favorite care" },
	{ id: "help", label: "Help", keywords: "question support faq" },
	{ id: "home", label: "Home", keywords: "house landing" },
	{ id: "key", label: "Key", keywords: "access unlock security" },
	{ id: "language", label: "Language", keywords: "translate global words" },
	{ id: "leaf", label: "Leaf", keywords: "nature sustainable organic" },
	{ id: "lock", label: "Lock", keywords: "secure privacy protection" },
	{ id: "mail", label: "Mail", keywords: "email message contact" },
	{ id: "location", label: "Location", keywords: "map pin place" },
	{ id: "message", label: "Message", keywords: "chat comment support" },
	{ id: "microphone", label: "Microphone", keywords: "audio podcast speak" },
	{ id: "package", label: "Package", keywords: "box product delivery" },
	{ id: "palette", label: "Palette", keywords: "design color creative" },
	{ id: "phone", label: "Phone", keywords: "call mobile contact" },
	{ id: "photo", label: "Photo", keywords: "image picture media" },
	{ id: "plant", label: "Plant", keywords: "nature grow organic" },
	{ id: "play", label: "Play", keywords: "video media watch" },
	{ id: "puzzle", label: "Puzzle", keywords: "integration solution" },
	{ id: "receipt", label: "Receipt", keywords: "payment invoice purchase" },
	{ id: "rocket", label: "Rocket", keywords: "launch fast growth" },
	{ id: "school", label: "School", keywords: "education academy learn" },
	{ id: "search", label: "Search", keywords: "find discover" },
	{ id: "send", label: "Send", keywords: "message email share" },
	{ id: "settings", label: "Settings", keywords: "gear customize control" },
	{ id: "shield", label: "Shield", keywords: "secure privacy protected" },
	{ id: "shopping-bag", label: "Shopping bag", keywords: "store commerce purchase" },
	{ id: "sparkles", label: "Sparkles", keywords: "magic ai new" },
	{ id: "speaker", label: "Speaker", keywords: "announcement marketing" },
	{ id: "star", label: "Star", keywords: "favorite rating quality" },
	{ id: "target", label: "Target", keywords: "goal focus aim" },
	{ id: "thumb-up", label: "Thumb up", keywords: "like approved yes" },
	{ id: "tools", label: "Tools", keywords: "build customize settings" },
	{ id: "growth", label: "Growth", keywords: "trending chart success" },
	{ id: "trophy", label: "Trophy", keywords: "winner award achievement" },
	{ id: "delivery", label: "Delivery", keywords: "truck shipping transport" },
	{ id: "user", label: "User", keywords: "person profile member" },
	{ id: "users", label: "Users", keywords: "people community team" },
	{ id: "video", label: "Video", keywords: "camera media watch" },
	{ id: "wallet", label: "Wallet", keywords: "money payment finance" },
	{ id: "wand", label: "Magic wand", keywords: "create ai magic" },
	{ id: "world", label: "World", keywords: "globe global internet" },
] as const

export type LandingFeatureIconId = (typeof landingFeatureIcons)[number]["id"]

export const landingFeatureIconIds = landingFeatureIcons.map(icon => icon.id)

const landingFeatureIconPrefix = "tabler:"
const landingFeatureIconsById = new Map<string, (typeof landingFeatureIcons)[number]>(
	landingFeatureIcons.map(icon => [icon.id, icon]),
)

export const getLandingFeatureIconValue = (id: string) => `${landingFeatureIconPrefix}${id}`

export const getLandingFeatureIconDefinition = (value: string) => {
	if (!value.startsWith(landingFeatureIconPrefix)) return undefined
	return landingFeatureIconsById.get(value.slice(landingFeatureIconPrefix.length))
}

export const isLandingFeatureIcon = (value: string) => getLandingFeatureIconDefinition(value) !== undefined
